/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { ifaApprovalGetResponseSchema } from './ifaApprovalGetResponseSchema.ts';

export const getIfaApprovalQueryParamsSchema = z.object({
  company: z.string(),
});

/**
 * @description 200 response
 */
export const getIfaApproval200Schema = z.lazy(() => ifaApprovalGetResponseSchema);

/**
 * @description 505 response
 */
export const getIfaApproval505Schema = z.any();

export const getIfaApprovalQueryResponseSchema = z.lazy(() => getIfaApproval200Schema);
